// *** Single import file for AMS namescape ***
import NavigationSearchBar from './NavigationSearchBar/NavigationSearchBar';
import NavigationCategoriesBar from './NavigationCategoriesBar/NavigationCategoriesBar';
import CategoriesDropdown from './NavigationCategoriesBar/CategoriesDropdown';
import SearchBar from './NavigationSearchBar/SearchBar';
import ShopCard from './ShopCard/ShopCard';
import Grid from './Grid/Grid';
import RenderLayoutViews from './shared/RenderLayoutViews';
import OfferCard from './Offer/OfferCard';
import Carousel from './Carousel/Carousel';
import GreetingSection from './GreetingSection/GreetingSection';
import TitledSection from './shared/TitledSection';
import MyZoneDropdown from './NavigationCategoriesBar/MyZoneDropdown';
import PromoContainer from './Promo/PromoContainer';
import LayoutLifestyleBanner from './LayoutLifestyleBanner/LayoutLifestyleBanner';
import LayoutAdContainer from './LayoutAdContainer/LayoutAdContainer';
import Footer from './Footer/Footer';
import Modal from './Modal/Modal';
import OfferModal from './OfferModal/OfferModal';
import GlobalBanner from './Banner/GlobalBanner';
import HomeContent from './Pages/HomeContent';
import SearchContent from './Pages/SearchContent';
import ShopPage from './ShopPage/ShopPage';
import ShopInfoCard from './ShopPage/ShopInfoCard';
import InterstitialPage from './InterstitialPage/InterstitialPage';
import MyZonePage from './MyZonePage/MyZonePage';
import DirectoryContent from './Pages/DirectoryContent';
import HelpPageContent from './HelpPage/HelpPageContent';
import CategoryPage from './CategoryPage/CategoryPage';
import HowItWorksPageContent from './HowItWorks/HowItWorksPageContent';
import BonusMilesPageContent from './BonusMiles/BonusMilesPageContent';
import TermsAndConditionsContent from './TermsAndConditions/TermsAndConditionsContent';
import SeasonalContent from './SeasonalPage/SeasonalContent';
import OnboardingModal from './OnboardingModal/OnboardingModal';
import SpecialOffersContent from './SpecialOffersPage/SpecialOffersContent';
import LayoutSmallPromoBanner from './LayoutSmallPromoBanner/LayoutSmallPromoBanner';
import SiteMapPageContent from './SiteMapPage/SiteMapPageContent';
import SplashPageContent from './SplashPage/SplashPageContent';
import ExtensionLanding from './Extension/ExtensionLanding';
import NotificationSlot from './Notifications/NotificationSlot';
import SessionExtensionContainer from './SessionExtension/SessionExtensionContainer';
import GlobalNavigation from './GlobalNavigation/GlobalNavigation';

export default {
  NavigationSearchBar,
  NavigationCategoriesBar,
  CategoriesDropdown,
  SearchBar,
  ShopCard,
  Grid,
  RenderLayoutViews,
  OfferCard,
  Carousel,
  GreetingSection,
  TitledSection,
  MyZoneDropdown,
  PromoContainer,
  LayoutLifestyleBanner,
  LayoutAdContainer,
  Footer,
  Modal,
  OfferModal,
  GlobalBanner,
  HomeContent,
  SearchContent,
  ShopPage,
  ShopInfoCard,
  InterstitialPage,
  MyZonePage,
  DirectoryContent,
  HelpPageContent,
  CategoryPage,
  HowItWorksPageContent,
  BonusMilesPageContent,
  TermsAndConditionsContent,
  SeasonalContent,
  OnboardingModal,
  SpecialOffersContent,
  LayoutSmallPromoBanner,
  SiteMapPageContent,
  SplashPageContent,
  ExtensionLanding,
  NotificationSlot,
  SessionExtensionContainer,
  GlobalNavigation,
};
